<template>
	<el-result icon="error" title="404" subTitle="找不到当前页面" class='error-result'>
		<template slot="extra">
			<el-button type="primary" size="medium" @click="goHome">返回主页</el-button>
		</template>
	</el-result>
</template>

<script>
	export default {
		name: 'NotFound',
		methods: {
			goHome() {
				this.$router.push({
					name: 'Home'
				})
			}
		},
		mounted() {
			this.$notify.info({
				title: '404页面',
				message: '愿事事顺利，不再迷路♥',
				duration: 5000
			});
		}
	}
</script>

<style>
	.error-result {
		margin: 150px auto;
	}
</style>
